import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import {
	ActionIcon,
	Box,
	Drawer,
	Flex,
	Stack,
	Text,
	Title,
	Image,
	Card,
} from '@mantine/core';
import { creatorActions } from '@/store/slices/creatorSlice';
import { formatPrice, getFileSrc } from '@/utils/utilities';
import { groupBy } from 'lodash';
import { DisplayAttributeValueName } from '@/components/ui/DisplayAttributeValueName';
import Logo from '@/assets/images/logo.png';
import { IconChevronLeft } from '@tabler/icons-react';

export const CreatorSummaryDrawer: FC = () => {
	const dispatch = useTypedDispatch();

	const { options, project, preset } = useTypedSelector(
		(state) => state.creator
	);

	const handleClose = () => {
		dispatch(creatorActions.updateOptions({ summaryDrawerOpened: false }));
	};

	const modules = options.isPresetMode
		? preset.creatorProductModules
		: project.creatorProductModules;

	return (
		<Drawer
			opened={options.summaryDrawerOpened}
			onClose={handleClose}
			title={
				<Flex justify="space-between">
					<Image src={Logo} w={200} className="creator-logo" />

					<ActionIcon onClick={handleClose} variant="transparent">
						<IconChevronLeft />
					</ActionIcon>
				</Flex>
			}
		>
			<Title order={4} mt="md" mb={4}>
				PODSUMOWANIE
			</Title>
			<Text c="dimmed" mb="lg">
				{modules.length} modułów
			</Text>
			<Stack gap="md">
				{Object.values(groupBy(modules, 'code')).map((creaProdModules) => {
					const creaProdModule = creaProdModules[0],
						price = creaProdModule.price / 100;

					return (
						<Card key={creaProdModule.id}>
							<Flex justify="space-between" align="flex-start">
								<Flex gap="md" mb="md">
									<Image
										src={getFileSrc(creaProdModule.productModule.image?.path)}
										w={80}
										h={80}
									/>
									<Box>
										<Text fw="bold" size="lg">
											Moduł: {creaProdModule.productModule.name}
										</Text>
										<Text c="dimmed" size="sm">
											{creaProdModule.code}
										</Text>
									</Box>
								</Flex>
								<Text c="dimmed">{creaProdModules.length} szt</Text>
							</Flex>

							<Stack gap="xs">
								{[...creaProdModule.selectedAttributeValues]
									.sort((a, b) => a.attribute.listOrder - b.attribute.listOrder)
									.map((selectedAttributeValue) => (
										<Flex
											key={selectedAttributeValue.id}
											justify="space-between"
										>
											<Text c="dimmed" size="sm">
												{selectedAttributeValue.attribute.name}:
											</Text>
											<Text fw="bold" size="sm">
												<DisplayAttributeValueName
													attributeValue={selectedAttributeValue}
												/>
											</Text>
										</Flex>
									))}
								<Flex justify="space-between">
									<Text c="dimmed" size="sm">
										Cena za sztukę:
									</Text>
									<Text fw="bold" size="sm">
										{formatPrice(price)}
									</Text>
								</Flex>
								<Flex justify="space-between">
									<Text c="dimmed" size="sm">
										Razem:
									</Text>
									<Text fw="bold" size="sm">
										{formatPrice(creaProdModules.length * price)}
									</Text>
								</Flex>
							</Stack>
						</Card>
					);
				})}
				<Card>
					<Flex justify="space-between" mb="md">
						<Text fw="bold">Razem:</Text>
						<Text fw="bold">{formatPrice(project.price / 100)}</Text>
					</Flex>
					<Text c="dimmed" size="sm">
						Produkcja: 21 dni roboczych
					</Text>
					<Text c="dimmed" size="sm">
						Darmowa dostawa
					</Text>
				</Card>
			</Stack>
		</Drawer>
	);
};
